import { createFileRoute } from '@tanstack/react-router';
import { HomePage } from '@web/modules/home/home-page';

export const Route = createFileRoute('/_app/')({
  component: HomePage,
});
